import styled from 'styled-components';
import { device } from 'src/styles/global';
import { NavLink } from 'react-router-dom';
import theme from 'src/styles/theme';

interface Props {
  $isExpanded: boolean;
}

interface CompanyNavLinkProps {
  $isExpanded: boolean;
}

export const SidebarContent = styled.div`
  display: flex;
  height: 100vh;
  overflow-y: hidden;
`;

export const SidebarWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  z-index: 998;
  @media ${device.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 240px;
    z-index: 1002;
    background-color: ${theme.colors.neutralC10};
    transition: transform 0.3s ease;
    transform: translateX(-100%);

    &.expanded {
      transform: translateX(0);
    }
  }
`;

export const CompanySelectionPanelWrapper = styled.div`
  position: fixed;
  z-index: 3000;
`;

export const PageContent = styled.div`
  flex: 1;
  overflow-y: auto;
  transition: margin-left 0.3s ease; /* Smooth adjustment with Sidebar */

  &.blurred {
    @media ${device.mobile} {
      filter: blur(6px); /* Applies the blur effect on mobile */
    }
  }
`;

export const CustomSidebarStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  height: '100%',
  width: '240px',
  minWidth: '106px',
  color: theme.colors.neutralW100,
  backgroundColor: theme.colors.neutralC10,
  padding: '40px 24px',
  gap: '8px',
};

export const NavItemWrapper = styled.div`
  padding-bottom: 8px;
`;

export const SidebarSectionDivider = styled.div`
  margin: 16px 0;
  border-top: 1px solid ${theme.colors.neutralC40};
`;

export const CompanyNavLink = styled(NavLink)<CompanyNavLinkProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isExpanded }) =>
    $isExpanded ? 'flex-start' : 'center'};
  gap: 8px;
  padding: 8px;
  border-radius: 5px;
  text-decoration: none;
  color: ${theme.colors.neutralW70};
  font-size: 16px;
  font-weight: 400;

  &:hover {
    background-color: ${theme.colors.neutralC20};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.mtr60};
    outline-offset: 2px;
  }
`;

export const CompanyIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CompanyInitials = styled.span`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  color: ${theme.colors.neutralW100};
`;

export const CompanyInfoWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CompanyLabel = styled.span`
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CompanyArrowWrapper = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const CompanyTooltipStyles = {
  marginLeft: '8px',
  marginTop: '0px',
  zIndex: 4000,
};

export const CustomNavItemStyles = {
  textDecoration: 'none',
};

export const SidebarFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoWrapper = styled.div<Props>`
  display: flex;
  align-items: flex-end;
  padding-bottom: 40px;
  transition: all 0.3s;

  svg {
    transition: all 0.3s;
    display: block;
  }
`;

export const NavLinkWrapper = styled(NavLink)`
  display: block;
  border-radius: 5px;

  &:focus-visible {
    outline: 2px solid ${theme.colors.mtr60};
    outline-offset: 2px;
  }
`;

export const GradientOverlay = styled.div`
  @media ${device.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.6) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1000;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease;

    &.active {
      visibility: visible;
      opacity: 1;
    }
  }
`;
